<div class="weekday-editor" [formGroup]="detailsFormGroup">
    <div>
        {{'weekdays' | translate:['tmc-yard.widgets.filter-administration.details-editor.transport.weekday-editor.weekday',
        translationService.language]}}
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="weekdayMonday" name="weekdayMonday">
            {{'any' | translate: ['tmc-yard.widgets.filter-administration.details-editor.transport.weekday-editor.weekday.monday',
            translationService.language]}}
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="weekdayTuesday" name="weekdayTuesday">
            {{'any' | translate: ['tmc-yard.widgets.filter-administration.details-editor.transport.weekday-editor.weekday.tuesday',
            translationService.language]}}
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="weekdayWednesday" name="weekdayWednesday">
            {{'any' | translate: ['tmc-yard.widgets.filter-administration.details-editor.transport.weekday-editor.weekday.wednesday',
            translationService.language]}}
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="weekdayThursday" name="weekdayThursday">
            {{'any' | translate: ['tmc-yard.widgets.filter-administration.details-editor.transport.weekday-editor.weekday.thursday',
            translationService.language]}}
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="weekdayFriday" name="weekdayFriday">
            {{'any' | translate: ['tmc-yard.widgets.filter-administration.details-editor.transport.weekday-editor.weekday.friday',
            translationService.language]}}
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="weekdaySaturday" name="weekdaySaturday">
            {{'any' | translate: ['tmc-yard.widgets.filter-administration.details-editor.transport.weekday-editor.weekday.saturday',
            translationService.language]}}
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="weekdaySunday" name="weekdaySunday">
            {{'any' | translate: ['tmc-yard.widgets.filter-administration.details-editor.transport.weekday-editor.weekday.sunday',
            translationService.language]}}
        </mat-checkbox>
    </div>

</div>